import React from 'react'
import styles from './cta.module.scss'

export default ({ children, ...props }) => (
  <div className={styles.inner} {...props}>
    {children}
  </div>
)
